import { useEffect } from 'react';
import { useUiStore } from './ui-store';

export function ThemeEffect() {
  const theme = useUiStore((s) => s.theme);
  useEffect(() => {
    document.documentElement.dataset.theme = theme;
  }, [theme]);
  return null;
}
